import { defineStore } from "pinia";

import type { Theme } from "../api/portal";

export type { Theme };

// The portal's accent colours, which the themed dialogs and buttons key on.
export type AccentTheme = "teal" | "grape" | "iceberg" | "rose" | "offsite";

// The last theme seen, so the login page paints in the right accent before the
// server answers. queries/theme.ts reads and refreshes it.
export const useThemeStore = defineStore("theme", {
  state: () => ({
    theme: null as Theme | null,
    themeFetchedAt: null as number | null,
  }),
  persist: {
    storage: "local",
  },
});
